import React, { useEffect, useRef, Profiler } from "react";
import AppShell from "../components/elements/AppShell";
import PostBookingPaymentInner from "../components/elements/PostBookingPaymentInner";
import PostBookingPaymentInnerLoader from "../components/elements/PostBookingPaymentInnerLoader";
import { Helmet } from "react-helmet-async";
import CheckoutLoadingScreen from "../components/elements/LoadingScreen/components/CheckoutLoadingScreen";
import useTrackPageLoad from "../hooks/useTrackPageLoad";
import useClientMetrics from "../hooks/useClientMetrics";
import { useParams } from "react-router-dom";
import NoSSR from "../app/NoSSR";

const PostBookingPayment = () => {
  const params = useParams<{ token: string }>();
  const trackContextEventV2 = useTrackPageLoad("pb_checkout_payment");
  const { trackRenderTime } = useClientMetrics();

  const contextTrackingRef = useRef({
    trackContextEventV2
  });

  useEffect(() => {
    const { trackContextEventV2 } = contextTrackingRef.current;
    trackContextEventV2();
  }, []);

  return (
    <Profiler id="screen" onRender={trackRenderTime}>
      <PageHeader />
      <AppShell noPadding>
        <NoSSR>
          <PostBookingPaymentInnerLoader token={params?.token}>
            <PostBookingPaymentInner />
          </PostBookingPaymentInnerLoader>
          <CheckoutLoadingScreen />
        </NoSSR>
      </AppShell>
    </Profiler>
  );
};

const PageHeader: React.FunctionComponent<{ isWebview?: boolean; children?: React.ReactNode }> = (props) => {
  return (
    <Helmet>
      <meta property="webview:header" content="regular" />
      <meta property="webview:title" content={""} />
      {props.children}
    </Helmet>
  );
};

export { PageHeader };
export default PostBookingPayment;
